const PricingMaster = {

    // FIELDS
    "sub_cat": "Sub Category",
    "brand": "Brand",
    "effective_date": "Effective Date",
    "effective_from": "Effective From",
    "customer": "Customer",
    "customer_cat": "Customer Category",
    "item": "Item",
    "old_rate": "Old Rate",
    "new_rate": "New Rate",
    "remark": "Remark",
    "search": "Search",

    // PAGE HEADER
    "product_pricing": "Product Pricing",
    "customer_pricing": "Customer Pricing",
    "customer_cat_pricing": "Customer Category Pricing",

    // SWEET ALERT
    "pricing_filter": "Pricing Filter",
    "customer_pricing_filter": "Customer Pricing Filter",
    "customer_category_pricing_filter": "Customer Category Pricing Filter",
    "pricing_filter_error": "Choose Effective Date & Either Brand or Sub-Category",
    "customer_pricing_filter_error": "Select Customer with Effective Date & Either Brand or Sub-Category",
    "customer_category_pricing_filter_error": "Select Customer Category with Effective Date & Either Brand or Sub-Category",

    // ERROR
    "error_sub_cat": "Select Sub Category",
    "error_brand": "Select Brand",
    "error_date": "Choose Date",
    "error_positive_no": "Positive number only",
    "error_rate": "Enter Rate",
    "error_item_nf": "Item not found",
    "error_customer": "Select Customer",
    "error_customer_cat": "Select Customer Category",

    // TABLE HEADER
    "table_effective_date": "EFFECTIVE DATE",
    "table_sub_cat": "SUB CATEGORY",
    "table_brand": "BRAND",
    "table_item": "ITEM",
    "table_price": 'PRICE',
    "table_customer": 'CUSTOMER',
    "table_customer_cat": 'CUSTOMER CATEGORY',
}

export default PricingMaster;